import React from 'react';

import PropTypes from 'prop-types';
import { MdInsertDriveFile } from 'react-icons/md';

import { S } from '@shared/components';

import styles from './UploadItem.less';

const GenericUploadItem = ({
  title,
  progressContent,
  actionContent,
  extraContent,
}) => (
  <div className={styles.container}>
    <div className={styles.mainContent}>
      <MdInsertDriveFile className={styles.fileIcon} />
      <div className={styles.progressContent}>
        <S size="5" className={styles.title}>
          {title}
        </S>
        {progressContent}
      </div>
      <div className={styles.actionContent}>{actionContent}</div>
    </div>
    <div className={styles.extraContent}>{extraContent}</div>
  </div>
);

GenericUploadItem.propTypes = {
  title: PropTypes.node.isRequired,
  progressContent: PropTypes.node.isRequired,
  actionContent: PropTypes.node.isRequired,
  extraContent: PropTypes.node,
};

export default GenericUploadItem;
